import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const retailerManagementSlide = createSlice({
    name: "retailerManagement",
    initialState: {
        page: 0,
        pageCount: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        responseData: null,
        errorDetailData: null,
        summaryData: null,
        totalRow: 0,
    },
    reducers: {
        doGetRetailerManagementListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
			state.pageCount = action.payload?.page_count;
			state.totalRow = action.payload?.total_row;
        },
        doGetRetailerManagementListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
			state.pageCount = 0;
			state.totalRow = 0;
        },
        doGetRetailerManagementSummarySuccess: (state, action) => {
            state.summaryData = action.payload?.data;
        },
        doGetRetailerManagementSummaryFail: (state, action) => {
            state.summaryData = null;
        },
        doGetRetailerManagementDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetRetailerManagementDetailFail: (state, action) => {
            state.detailData = null;
        },
        doAddRetailerManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
			state.responseData = action.payload;
        },
        doAddRetailerManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        doUpdateRetailerManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateRetailerManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },
        resetRetailerManagementStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
            state.detailData = null;
			state.errorDetailData = null;
        },
        resetRetailerManagementErrorState: (state) => {
            state.success = false;
            state.fail = false;
            state.errorDetailData = null;
        },
    },
});

export const doGetRetailerManagementList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/retail-management?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetRetailerManagementListSuccess(response.data));
    } catch (error) {
        dispatch(doGetRetailerManagementListFail(error.response));
    }
};

export const doGetRetailerManagementSummary = () => async (dispatch) => {
    try {
        const url = `/api/admin/retail-management/summary`;

        const response = await axios.get(url);
        dispatch(doGetRetailerManagementSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetRetailerManagementSummaryFail(error.response));
    }
};

export const doGetRetailerManagementDetail = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/retail-management/${param.retailer_id}`;
       
        const response = await axios.get(url);
        dispatch(doGetRetailerManagementDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetRetailerManagementDetailFail(error.response));
    }
};

export const doAddRetailerManagement = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/retail-management`;

        const response = await axios.post(url, param);
        dispatch(doAddRetailerManagementSuccess(response.data));
    } catch (error) {
        dispatch(doAddRetailerManagementFail(error.response));
    }
};

export const doUpdateRetailerManagement = (param, retailerId) => async (dispatch) => {
    try {
        const url = `/api/admin/retail-management/${retailerId}`;

        const response = await axios.put(url, param);
        dispatch(doUpdateRetailerManagementSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateRetailerManagementFail(error.response));
    }
};


export const resetRetailerManagementState = () => async (dispatch) => {
    dispatch(resetRetailerManagementStateSuccess(false));
 };

export const { 
    doGetRetailerManagementListSuccess,
    doGetRetailerManagementListFail,
    doGetRetailerManagementSummarySuccess,
    doGetRetailerManagementSummaryFail,
    doGetRetailerManagementDetailSuccess,
    doGetRetailerManagementDetailFail,
    doAddRetailerManagementSuccess,
    doAddRetailerManagementFail,
    doUpdateRetailerManagementSuccess,
    doUpdateRetailerManagementFail,
    resetRetailerManagementStateSuccess,
    resetRetailerManagementErrorState,
} = retailerManagementSlide.actions;

export const getRetailerManagementList = (state) => state.retailerManagement?.listData;
export const getRetailerManagementListPage = (state) => state.retailerManagement?.page;
export const getRetailerManagementListPageCount = (state) => state.retailerManagement?.pageCount;
export const getRetailerManagementListTotal = (state) => state.retailerManagement?.totalRow;
export const getRetailerManagementSummary = (state) => state.retailerManagement?.summaryData;
export const getRetailerManagementDetail = (state) => state.retailerManagement?.detailData;
export const getRetailerManagementErrorDetailData = (state) => state.retailerManagement?.errorDetailData;
export const getAddRetailerManagementSuccess = (state) => state.retailerManagement?.success;
export const getAddRetailerManagementFail = (state) => state.retailerManagement?.fail;
export const getAddRetailerManagementResponseData = (state) => state.retailerManagement?.responseData;

export default retailerManagementSlide.reducer;
